import axios from "axios";
import { useState,useEffect } from "react";
import { REGISTER_USERDATA_URL } from "../../../../DataStore/ApiConstant";
import TranslatesContent from "../../../../DataStore/Languages/translatesContent";
import CountryListSelect from "../../CountryListSelect";
import MobileField from "../../MobileFIeld";
import RegisterButton from "./RegisterButton";
import { REGISTER_URL, FORGOT_PASSWORD_URL } from "../../../../DataStore/ApiConstant";

import OtpForm from "./OtpForm";

const GeneralInfo = ({ setFormType, openGeneralModal }) => {
  const [fullname, setFullname] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [promocode, setPromocode] = useState("");
  const [gender, setGender] = useState("male");
  const [username, setUsername] = useState("");
  const [initPassword, setPassword] = useState("");
  const [confirmedPass, setConfirmedPass] = useState("");

  const [showInitPassword, setShowInitPassword] = useState(false);
  const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);

  const [nameErr, setNameErr] = useState("");
  const [mobileNumErr, setMobileNumErr] = useState("");
  const [dobErr, setDobErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [promoCodeErr, setPromoCodeErr] = useState("");
  const [usernameErr, setUsernameErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [country, setCountry] = useState("LK-94");
  // const [phone , setPhone] = useState('')
  const [phoneNumber, setPhone] = useState("");

  // const [recapthatoken , setToken] = useState(null);
  const [registerErr, setRegisterErr] = useState(null);
  const [phoneNumErr, setPhoneNumErr] = useState(null);
  const [resetPassword, setResetPassword] = useState('');

  const [showOtpForm, setShowOtpForm] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [phoneVerifyErr, setPhoneVerifyErr] = useState("");

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsErr, setTermsErr] = useState(""); 

  const countryVal = country;
  const countryFormatted = countryVal.split("-")[0];

  const phoneVal = phoneNumber;
  let phoneFormatted = countryVal.split("-")[1] + phoneVal;
  phoneFormatted= "+"+phoneFormatted
  const [formErr, setFormErr] = useState("");

  let msg={
    "already":"This Mobile number already exist..",
    "Invalid Mobile Number":"Invalid Mobile Number",
  }
  const verifyPassword = (password, what) => {
    setPassword(password);
    if (!confirmedPass) {
      if (password) {
        setPasswordErr("Repeat password is required");
      } else {
        setPasswordErr("");
      }
    } else if (password !== confirmedPass) {
      setPasswordErr("Password doesn't match");
    } else {
      setPasswordErr("");
    }
  };
    const updatePhone = (e) => {
    // if(e.target.value.length > 9){
    //   setPhoneNumErr("Invalid phone number")
    //   return
    // }else{
    //   setPhoneNumErr("")
    // }
    setPhone(e.target.value);
    setShowOtpForm(false);
    setIsPhoneVerified(false);
    setPhoneVerifyErr("");
    // setPhoneNum(e.target.value);
  };

    const countrySelected = (e) => {
    setCountry(e.target.value);
    setShowOtpForm(false);
    setIsPhoneVerified(false);
    setPhoneVerifyErr("");
  };

  // Simple email validator
  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const registerSubmit = (e, token) => {
    e.preventDefault();
    setRegisterErr("")
    setPhoneNumErr("")
    setResetPassword("")
    setShowOtpForm(false);
    setIsPhoneVerified(false);
    setPhoneVerifyErr("");
    let countryValue = country.split("-")[1];
    // console.log(country);
    let data = {
      country: country,
      phone: phoneNumber,
      token: token,
    };
    // return on recaptha error
    token === null
      ? setRegisterErr("recaptha failed! try again.")
      : phoneNumber === ""
      ? setRegisterErr("Please enter phone number!")
      : axios
      .post(REGISTER_URL, data)
          .then((resp) => {
            console.log();
            if (resp.data === "ok") {
              setShowOtpForm(true);
            }else if (resp.data === "already") {
              setResetPassword('This mobile number already Registered, please provide another number. '+ phoneNumber)
              // axios.get(`${FORGOT_PASSWORD_URL}?code=${countryValue}&contact=${phoneNumber}&token=${token}`).then((resp) => {
              //   if(resp.data =='done'){
              //   } else{
              //     setResetPassword(resp.data)
              //   }
              // }).catch((err) => {});
            } else {
              setRegisterErr(msg[resp.data]);
            }
          })
          .catch((err) => {});
  };

  const submitGeneralInfo = () => {
    setFormErr("")
    setPasswordErr("") 
    setPhoneVerifyErr("")
    fullname.trim() === "" ? setNameErr("Name Required") : setNameErr("")
    phoneFormatted == "" ? setMobileNumErr("Phone number not valid") : setMobileNumErr("")
    dob == "" ? setDobErr("Invalid date of birth") : setDobErr("")
    email.trim() === "" ? setEmailErr("Email is required") : (!isValidEmail(email) ? setEmailErr("Invalid email address") : setEmailErr(""))
    username.trim() === "" ? setUsernameErr("Username Required") : /\s/.test(username) ? setUsernameErr("Username cannot contain spaces") : setUsernameErr("")

    // password validations
    if (initPassword.trim() === "") {
      setPasswordErr("Password is required");
    } else if (confirmedPass.trim() === "") {
      setPasswordErr("Repeat password is required");
    } else if (initPassword !== confirmedPass) {
      setPasswordErr("Password doesn't match");
    } else {
      setPasswordErr("");
    }

    if(!termsAccepted){
      return setFormErr("Please accept terms and conditions to continue");
    }

    if (!isPhoneVerified) {
      setPhoneVerifyErr("Please verify the phone number");
      return;
    }
    
    if (fullname.trim() === "" || countryFormatted == "" || phoneFormatted =="" || dob == "" || email.trim() === "" || !isValidEmail(email) || username.trim() === "" || /\s/.test(username) || confirmedPass.trim() =="" || initPassword.trim()=="")  return
    if(initPassword !== confirmedPass){
      setPasswordErr("Password doesn't match");
      return; 
    }

    const formData = new FormData();
    formData.append("name", fullname);
    formData.append("country", countryFormatted);
    if (isPhoneVerified) {
      formData.append("phone", phoneFormatted);
    }
    formData.append("dob", dob);
    formData.append("email", email);
    formData.append("promocode", promocode);
    formData.append("gender", gender);
    formData.append("usname", username);
    formData.append("passw", confirmedPass);
    formData.append("btag", "");
    formData.append("referral", "");

    axios
      .post(REGISTER_USERDATA_URL, formData)
      .then((resp) => {
        if(resp.data === "done"){
          return setFormType("success");
        }
       if( resp.data=== "err") {
          return setFormErr("Fill out all the required fields");
       }
       if( resp.data=== "age") {
          return setFormErr("Age must be grater than 18");
       }
       if( resp.data=== "Username is already Taken") {
          return setFormErr("Username is already Taken");
       }

        if (resp.data !== "done" || resp.data !== "success") {
          if (resp.data === "Acc false") {
            setFormErr("Something went wrong!");
          } else {
            setFormErr(resp.data);
          }
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    const syncPromoCode = () => {
      let promoFromHash = "";

      try {
        const url = new URL(window.location.href);
        promoFromHash = (url.hash || "").replace(/^#/, "");
      } catch (e) {
        promoFromHash = (window.location.hash || "").replace(/^#/, "");
      }

      const storedPromoCode =
        localStorage.getItem("promoCode") ||
        localStorage.getItem("promocode") ||
        "";

      const finalPromoCode = promoFromHash || storedPromoCode;
      if (!finalPromoCode) return;

      setPromocode(finalPromoCode);
      localStorage.setItem("promoCode", finalPromoCode);
      localStorage.setItem("promocode", finalPromoCode);
    };

    syncPromoCode();
    window.addEventListener("hashchange", syncPromoCode);
    return () => window.removeEventListener("hashchange", syncPromoCode);
  },[])
  return (
    <div className="general-info-form-wrapper">
      <div
        className="col-12 subTitel text-center"
        style={{ color: "#ffffff", fontSize: "0.7rem" }}
      >
         <TranslatesContent contentKey="join-verify" />
      </div>
      <div className="row">
        <div className="mt-2">
          <div className="col-12">
            <label htmlFor="full-name">
              <TranslatesContent contentKey="fullname" />*
            </label>
            <input
              type="text"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              className="form-control form-control-cashier"
            />
          <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
            {nameErr && nameErr}
          </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label htmlFor="full-name">
                <TranslatesContent contentKey="join-now-country" /> *
              </label>
              <CountryListSelect
                selectedCountry={country}
                countrySelected={countrySelected}
              />
              {/* <input
                type="text"
                value={countryFormatted}
                readOnly
                className="form-control form-control-cashier"
              /> */}

            </div>
            <div className="col-6">
              <label htmlFor="full-name">
                {" "}
                <TranslatesContent contentKey="date-of-birth" /> *
              </label>
              <input
                type="date"
                onChange={(e) => setDob(e.target.value)}
                className="form-control form-control-cashier"
              />
            <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
              {dobErr && dobErr}
            </div>
            </div>
          </div>
          
        </div>
        <div className="mt-2">
          <div className="col-12">
            {/* <label htmlFor="full-name">
              <TranslatesContent contentKey="mobile-number" /> *
            </label> */}
              <MobileField
                country={country}
                updatePhone={updatePhone}
                phoneNumber={phoneNumber}
              />
            {/* <input
              type="text"
              readOnly
              value={phone}
              className="form-control form-control-cashier"
            /> */}
                  {!showOtpForm && !isPhoneVerified && (
                    <RegisterButton registerSubmit={registerSubmit} />
                  )}
          <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
              <div className="register-error m-2"  >
                {registerErr && registerErr}
            </div>
              <div className="register-error" >
                {phoneNumErr && phoneNumErr}
              </div>
              <div >
                {resetPassword && resetPassword}
              </div>
              <div >
                {phoneVerifyErr && phoneVerifyErr}
              </div>
          </div>
          </div>
      {showOtpForm && (
        <OtpForm
          setFormType={setFormType}
          country={country}
          phone={phoneNumber}
          onVerified={() => {
            setIsPhoneVerified(true);
            setShowOtpForm(false);
            setPhoneVerifyErr("");
          }}
        />
      )}
        </div>
        <div className="mt-2">
          <div className="col-12">
            <label htmlFor="full-name">
              {" "}
              <TranslatesContent contentKey="email" />
            </label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              onBlur={(e) => {
                const val = e.target.value.trim();
                setEmail(val);
                if (!val) setEmailErr("Email is required");
                else if (!isValidEmail(val)) setEmailErr("Invalid email address");
                else setEmailErr("");
              }}
              type="email"
              required
              className="form-control form-control-cashier"
            />
          <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
            {emailErr && emailErr}
          </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <label htmlFor="full-name">
                <TranslatesContent contentKey="promo-code" />
              </label>
              <input
                onChange={(e) => {
                  const nextValue = e.target.value;
                  setPromocode(nextValue);
                  setPromoCodeErr("");
                  localStorage.setItem("promoCode", nextValue);
                  localStorage.setItem("promocode", nextValue);
                }}
                onBlur={(e) => {
                  const trimmed = e.target.value.trim();
                  if (trimmed !== promocode) {
                    setPromocode(trimmed);
                    localStorage.setItem("promoCode", trimmed);
                    localStorage.setItem("promocode", trimmed);
                  }
                }}
                value={promocode}
                type="text"
                className="form-control form-control-cashier"
              />
            <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
              {promoCodeErr && promoCodeErr}
            </div>
            </div>
            <div className="col-md-6">
              <label htmlFor="full-name">
                {" "}
                <TranslatesContent contentKey="gender" />
              </label>
              <select
                onChange={(e) => setGender(e.target.value)}
                name=""
                id=""
                className="form-select form-control-cashier"
              >
                <option value={"male"}>
                  <TranslatesContent contentKey="male" />
                </option>
                <option value={"female"}>
                  <TranslatesContent contentKey="female" />
                </option>
              </select>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <div className="col-12">
            <label htmlFor="full-name">
              <TranslatesContent contentKey="username-register" />*
            </label>
            <input
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => { if (e.key === ' ') e.preventDefault(); }}
              onPaste={(e) => {
                const text = e.clipboardData.getData('text');
                if (/\s/.test(text)) {
                  e.preventDefault();
                  setUsername(text.replace(/\s+/g, ""));
                  setUsernameErr("Username cannot contain spaces");
                }
              }}
              pattern="^\S+$"
              title="Username cannot contain spaces"
              type="text"
              className="form-control form-control-cashier"
            />
          <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
            {usernameErr && usernameErr}
          </div>
          </div>
          <div className="col-12">
            <label htmlFor="full-name">
              <TranslatesContent contentKey="password-register" />*
            </label>
            <div className="input-group">
              <input
                type={showInitPassword ? "text" : "password"}
                value={initPassword}
                onChange={(e) => verifyPassword(e.target.value, "init")}
                className="form-control form-control-cashier"
                autoComplete="new-password"
              />
              <button
                type="button"
                className="d-flex align-items-center justify-content-center passwordShowButton"
                onClick={() => setShowInitPassword((prev) => !prev)}
                aria-label={showInitPassword ? "Hide password" : "Show password"}
                aria-pressed={showInitPassword}
                title={showInitPassword ? "Hide password" : "Show password"}
              >
                <i
                  className={
                    showInitPassword
                      ? "fa-solid fa-eye-slash passwordHideBlack"
                      : "fa-solid fa-eye passwordHideBlack"
                  }
                  aria-hidden="true"
                />
                <span className="visually-hidden">
                  {showInitPassword ? "Hide password" : "Show password"}
                </span>
              </button>
            </div>
          </div>
          <div className="col-12">
            <label htmlFor="full-name">
              <TranslatesContent contentKey="repeat-password" />*
            </label>
            <div className="input-group">
              <input
                value={confirmedPass}
                onChange={(e) => {
                  const val = e.target.value;
                  setConfirmedPass(val);
                  if (!val) {
                    if (initPassword) setPasswordErr("Repeat password is required");
                    else setPasswordErr("");
                  } else if (initPassword && val !== initPassword) {
                    setPasswordErr("Password doesn't match");
                  } else {
                    setPasswordErr("");
                  }
                }}
                onBlur={() => {
                  if (!confirmedPass) setPasswordErr("Repeat password is required");
                }}
                type={showConfirmedPassword ? "text" : "password"}
                className="form-control form-control-cashier"
                autoComplete="new-password"
              />
              <button
                type="button"
                className="d-flex align-items-center justify-content-center passwordShowButton"
                onClick={() => setShowConfirmedPassword((prev) => !prev)}
                aria-label={showConfirmedPassword ? "Hide password" : "Show password"}
                aria-pressed={showConfirmedPassword}
                title={showConfirmedPassword ? "Hide password" : "Show password"}
              >
                <i
                  className={
                    showConfirmedPassword
                      ? "fa-solid fa-eye-slash passwordHideBlack"
                      : "fa-solid fa-eye passwordHideBlack"
                  }
                  aria-hidden="true"
                />
                <span className="visually-hidden">
                  {showConfirmedPassword ? "Hide password" : "Show password"}
                </span>
              </button>
            </div>
          <div className="general-form-error mt-3" style={{ color: "red" }}>
            {passwordErr && passwordErr}
          </div>
          </div>
        </div>
      </div>
      <div className="general-form-error mt-1 registerformErrors" style={{ color: "red" }}>
        {formErr && formErr}
      </div>
      <div className="mt-4 d-flex align-items-center">
        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) => setTermsAccepted(e.target.checked)}
          id="terms-checkbox"
          style={{
            marginRight: "10px",
            width: "50px", 
            height: "50px", 
          }}
        />
        <label htmlFor="terms-checkbox" >
        <TranslatesContent contentKey="read-agrement-1" />
          <a href="" style={{color:"white", textDecoration:"underline"}} onClick={(e) => {
            e.preventDefault();
            openGeneralModal("agreement");}}><TranslatesContent contentKey="user-agreement" /></a>
        , <a href="" style={{color:"white", textDecoration:"underline"}} onClick={(e) => {
            e.preventDefault();
            openGeneralModal("customerVerification");}}><TranslatesContent contentKey="customerVerification" /></a>
        <TranslatesContent contentKey="read-agrement-2" />
        </label>
        <div className="general-form-error mt-2 registerformErrors" style={{ color: "red" }}>
          {termsErr && termsErr}
        </div>
      </div>

      <div className="text-center mt-4">
        <button className="frontButton3" onClick={(e) => submitGeneralInfo()}>
          <TranslatesContent contentKey="submit-cashier" />
        </button>
      </div>

    </div>
  );
};

export default GeneralInfo;
